import { WBAlert, WBTypography } from "@apptractive/design-system-web";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PATHS } from "../navigation/paths";
import { Link } from "./Link";

type SubscriptionUpgradeAlertProps = {
  remaining: number;
  titleRemaining: string;
  titleUpgrade: string;
  titleMaximum: string;
  isOwner: boolean;
  isExpired: boolean;
  isBrand: boolean;
  canUpgrade: boolean;
};
export const SubscriptionStatusAlert = ({
  remaining,
  titleRemaining,
  titleUpgrade,
  titleMaximum,
  isOwner,
  isExpired,
  isBrand,
  canUpgrade,
}: SubscriptionUpgradeAlertProps) => {
  const { t } = useTranslation();

  const getTitle = useCallback(() => {
    if (isExpired && isOwner) {
      return t("subscriptionExpiredRenew", { ns: "purchase" });
    }

    if (isExpired && !isOwner) {
      return t("teamSubscriptionExpired", { ns: "purchase" });
    }

    if (isOwner && isBrand && canUpgrade) {
      return titleUpgrade;
    }

    if (isBrand) {
      return titleMaximum;
    }
  }, [isExpired, isOwner, titleUpgrade, titleMaximum, isBrand, canUpgrade, t]);

  return (
    <>
      {isBrand && remaining > 0 && !isExpired && (
        <WBTypography color="grey.500">
          {`${remaining} ${titleRemaining}`}
        </WBTypography>
      )}

      {((isBrand && remaining === 0) || isExpired) && (
        <WBAlert
          sx={{
            mt: 1,
          }}
          severity={isExpired ? "error" : "warning"}
          title={getTitle()}
        >
          {(isExpired || canUpgrade) && isOwner && (
            <Link to={PATHS.plans}>
              {t(isExpired ? "renewTitle" : "upgradeTitle", { ns: "common" })}
            </Link>
          )}
        </WBAlert>
      )}
    </>
  );
};
